var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69231 5.53938L13.8175 11.9861L3.69231 18.4329V5.53845V5.53938Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0769 5.53938L21.2022 11.9861L11.0769 18.4329V5.53845V5.53938Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackSkip);
export default __webpack_public_path__ + "static/media/track-skip.f8c46fcf81d18c67d8197dbd51722e7d.svg";
export { ForwardRef as ReactComponent };